import { useTranslation } from 'react-i18next';
import { View } from 'react-native';
import { COLOR, SPACING } from 'constants/design-system';

import { useAppSelector } from 'store/hooks';
import { UserSelectors } from 'store/User';
import { useCurrencyString } from 'util/helpers/currency';
import { BaseCard } from 'components/BaseCard';

import { FinancialInfoCardItem } from './FinancialInfoCardItem';
import type { FinancialInfo } from 'store/Orders/types';

export type FinancialInfoCardProps = {
  financialInfo: FinancialInfo;
};

export const FinancialInfoCard = (props: FinancialInfoCardProps) => {
  const { financialInfo } = props;
  const { t } = useTranslation();

  const getCurrencyString = useCurrencyString();

  const account = useAppSelector(UserSelectors.selectAccount);

  const financialInfoFeatureFlag = account.financial_info;

  return (
    <BaseCard
      style={{ backgroundColor: COLOR.theme.black, gap: SPACING.theme[8] }}
    >
      <View style={{ flexDirection: 'row', gap: SPACING.theme[8] }}>
        <FinancialInfoCardItem
          label={t('overview.orderDetails.subtotal')}
          value={getCurrencyString(financialInfo.items_subtotal)}
          style={{ flex: 1 }}
          hide={!financialInfoFeatureFlag?.items_subtotal}
        />

        <FinancialInfoCardItem
          label={t('overview.orderDetails.fee')}
          value={getCurrencyString(financialInfo.delivery_fee)}
          style={{ flex: 1 }}
          hide={!financialInfoFeatureFlag?.delivery_fee}
        />
        <FinancialInfoCardItem
          label={t('overview.orderDetails.credit')}
          value={getCurrencyString(financialInfo.credit)}
          style={{ flex: 1 }}
          hide={!financialInfoFeatureFlag?.credit}
        />
        <FinancialInfoCardItem
          label={t('overview.orderDetails.total')}
          value={getCurrencyString(financialInfo.grand_total_including_tax)}
          style={{ flex: 1 }}
          hide={!financialInfoFeatureFlag?.grand_total_including_tax}
        />
      </View>
      <View style={{ flexDirection: 'row', gap: SPACING.theme[8] }}>
        <FinancialInfoCardItem
          label={t('overview.orderDetails.deposit')}
          value={getCurrencyString(financialInfo.deposit)}
          style={{ flex: 1 }}
          hide={!financialInfoFeatureFlag?.deposit}
        />
        <FinancialInfoCardItem
          label={t('overview.orderDetails.discount')}
          value={getCurrencyString(financialInfo.discount)}
          style={{ flex: 1 }}
          hide={!financialInfoFeatureFlag?.discount}
        />
        <FinancialInfoCardItem
          label={t('overview.orderDetails.tax')}
          value={getCurrencyString(financialInfo.tax)}
          style={{ flex: 1 }}
          hide={!financialInfoFeatureFlag?.tax}
        />
        <FinancialInfoCardItem
          label={t('overview.orderDetails.tip')}
          value={getCurrencyString(financialInfo.total_tip_left_for_driver)}
          style={{ flex: 1 }}
          hide={!financialInfoFeatureFlag?.total_tip_left_for_driver}
        />
      </View>
    </BaseCard>
  );
};
